
export const formatBytes = (bytes: number, decimals: number = 2): string => {
  if (bytes === 0 || bytes < 0) return '0 Bytes'; // Handle cases where size is 0 or -1 (unknown)
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};

export const formatMilliseconds = (ms: number, decimals: number = 2): string => {
  if (ms < 0) return 'N/A'; // Timings can be -1
  if (ms < 1000) {
    return parseFloat(ms.toFixed(decimals)) + ' ms';
  }
  return parseFloat((ms / 1000).toFixed(decimals)) + ' s';
};

export const prettifyJson = (jsonString: string | undefined | null): string => {
  if (!jsonString) return 'No content';
  try {
    // Attempt to remove markdown fences if present
    let parsableString = jsonString.trim();
    const fenceRegex = /^```(\w*)?\s*\n?(.*?)\n?\s*```$/s;
    const match = parsableString.match(fenceRegex);
    if (match && match[2]) {
      parsableString = match[2].trim();
    }
    
    const jsonObj = JSON.parse(parsableString);
    return JSON.stringify(jsonObj, null, 2);
  } catch (error) {
    // If it's not valid JSON (or fails after attempting to strip fences), return the original string.
    // This is useful for non-JSON text content.
    return jsonString;
  }
};

export const getUrlWithoutDomain = (url: string): string => {
  try {
    const urlObj = new URL(url);
    let path = urlObj.pathname + urlObj.search + urlObj.hash;
    if (path.startsWith('/')) {
      path = path.substring(1);
    }
    return path;

  } catch (e) {
    // If the URL is invalid, return the original string
    return url;
  }
};

